import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '@/api/errors'

/**
 * One cache for the whole app.
 *
 * The retry policy is the interesting part: a 4xx is the server's considered answer and asking
 * again cannot change it, so only transient failures are retried. Retrying a 403 is how a UI
 * ends up hammering a backend it will never satisfy.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && !error.isTransient) return false
          return failureCount < 2
        },
      },
      mutations: {
        // Never retried. A mutation that timed out may well have succeeded, and repeating a
        // "disable this account" is not a safe guess to make on someone's behalf.
        retry: false,
      },
    },
  })
}
